import {ConnectionUserInfoObj} from './ConnectionUserInfoObj';

export class DatabaseConfigurationObj {
defaultSchema: string;
kind: string;
name: string;
userInfo: ConnectionUserInfoObj;
}

